var React = require('react');

function Wechat (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.5,17.23A5.69,5.69,0,0,0,24,12.67c0-3.32-3.24-6-7.23-6s-7.23,2.7-7.23,6,3.24,6,7.23,6a8.57,8.57,0,0,0,2.36-.33h.21a.77.77,0,0,1,.39.11l1.58.91.14.05a.24.24,0,0,0,.24-.24V19l-.33-1.22v-.15A.51.51,0,0,1,21.5,17.23ZM8.68,0C3.88,0,0,3.24,0,7.23a6.79,6.79,0,0,0,3,5.46.59.59,0,0,1,.24.47v.19l-.39,1.46V15a.29.29,0,0,0,.29.29l.17-.06,1.9-1.09A.86.86,0,0,1,5.59,14h.25a10.1,10.1,0,0,0,2.84.4h.47a5.61,5.61,0,0,1-.29-1.77C8.86,9,12.4,6,16.77,6h.47C16.59,2.64,13,0,8.68,0Zm5.68,11.71a1,1,0,1,1,1-1,1,1,0,0,1-1,1Zm4.82,0a1,1,0,1,1,1-1A1,1,0,0,1,19.18,11.71ZM5.78,6.07A1.16,1.16,0,1,1,6.94,4.91h0A1.14,1.14,0,0,1,5.79,6.07Zm5.79,0A1.16,1.16,0,1,1,12.72,4.9v0A1.17,1.17,0,0,1,11.57,6.07Z"}));
}

Wechat.defaultProps = {"viewBox":"0 0 24 19.41"};

module.exports = Wechat;

Wechat.default = Wechat;
